import { api } from '@/shared/lib/api'

export interface SubmitCsatPayload {
  csat_campaign_id: number
  csat_topic_id?: number | null
  score: number
  context_type?: string | null
  context_id?: number | null
  extra_answers?: Record<string, unknown>
  answered_on: string
}

// Envia a resposta CSAT ao endpoint dedicado de recebimento do backend.
export const submitCsat = async (
  digitalProductId: string,
  payload: SubmitCsatPayload
) => {
  const { data } = await api.post(
    `/user/digital_products/${digitalProductId}/csat_submissions`,
    { record: payload }
  )

  return data
}

// Data local no formato `YYYY-MM-DD` usada por `answered_on`.
export const today = () => {
  const now = new Date()
  const offset = now.getTimezoneOffset() * 60000
  return new Date(now.getTime() - offset).toISOString().slice(0, 10)
}
